import { getUserOption } from './options';

export function getTicketTypeColorDefaults() {
    return [
        { 'type': 'cancel', 'label': 'Cancel', 'color': '#795548', 'class': 'brown-lighten-1', 'selected': true },
        { 'type': 'damage', 'label': 'Damage', 'color': '#9c27b0', 'class': 'purple-darken-1', 'selected': true },
        { 'type': 'overdue', 'label': 'Overdue', 'color': '#FFEB3B', 'class': 'yellow-darken-1', 'selected': true },
        { 'type': 'due4', 'label': 'Due <4 Hrs', 'color': '#ff9800', 'class': 'orange-darken-1', 'selected': true },
        { 'type': 'due8', 'label': 'Due <8 Hrs', 'color': '#f44336', 'class': 'red-lighten-4', 'selected': true },
        { 'type': 'due24', 'label': 'Due <24 Hrs', 'color': '#B71C1C', 'class': 'red-darken-2', 'selected': true },
        { 'type': 'due48', 'label': 'Due <48 Hrs', 'color': '#B71C1C', 'class': 'red-darken-2', 'selected': true },
        { 'type': 'short_notice', 'label': 'Short Notice', 'color': '#ffeb3b', 'class': 'yellow-darken-1', 'selected': true },
        { 'type': 'late', 'label': 'Late', 'color': '#ffc107', 'class': 'amber-darken-2', 'selected': true },
        { 'type': 'update', 'label': 'Update', 'color': '#8bc34a', 'class': 'light-green-darken-1', 'selected': true },
        { 'type': 'grids', 'label': 'Grids', 'color': '#680059', 'class': 'purple-darken-3', 'selected': true },
        { 'type': 'polygons', 'label': 'Polygons', 'color': '#00A65D', 'class': 'green-darken-1', 'selected': true },
        { 'type': 'emergency', 'label': 'Emergency', 'color': '#B71C1C', 'class': 'red-darken-2', 'selected': true },
        { 'type': 'meet', 'label': 'Meet', 'color': '#3366FF', 'class': 'blue-darken-1', 'selected': true },
        { 'type': 'design', 'label': 'Design', 'color': '#3366FF', 'class': 'blue-darken-1', 'selected': true },
        { 'type': 'remark', 'label': 'Remark', 'color': '#FFCCBC', 'class': 'orange-lighten-3', 'selected': true },
    ];
}

export function getTicketTypeColors() {
    // In the case that the getTicketTypeColorDefaults() function is updated, 
    // we need to make sure that the user's saved colors are updated as well.
    // This is done by checking the saved colors against the defaults and
    // adding any missing types.
    let savedColors = getUserOption('JSON:UI-COLORS');
    if (savedColors) {
        try {
            savedColors = JSON.parse(savedColors);
            const defaults = getTicketTypeColorDefaults();
            for (const defaultColor of defaults) {
                const savedColor = savedColors.find((color) => color.type === defaultColor.type);
                if (!savedColor) {
                    savedColors.push(defaultColor);
                }
            }            
            return savedColors;
        } catch (e) {
            console.error(e);
            return getTicketTypeColorDefaults();
        }
    }
    return getTicketTypeColorDefaults();
}

export function getColorCatalog() {
    return [
        {
            class: 'brown-darken-1',
            color: '#663300',
        },
        {
            class: 'purple-darken-2',
            color: '#8E24AA',
        },
        {
            class: 'red-darken-2',
            color: '#B71C1C',
        },
        {
            class: 'orange-lighten-1',
            color: '#FF7043',
        },
        {
            class: 'orange-lighten-2',
            color: '#FFAB91',
        },
        {
            class: 'orange-lighten-3',
            color: '#FFCCBC',
        },
        {
            class: 'yellow-darken-1',
            color: '#FFEB3B',
        },
        {
            class: 'amber-darken-2',
            color: '#FFB300',
        },
        {
            class: 'light-green-darken-1',
            color: '#8BC34A',
        },
        {
            class: 'brown-lighten-1',
            color: '#996633',
        },
        {
            class: 'green-darken-1',
            color: '#00A65D',
        },
        {
            class: 'purple-darken-3',
            color: '#680059',
        },
        {
            class: 'blue-darken-1',
            color: '#3366FF',
        },
        {
            class: 'light-green-lighten-1',
            color: '#DCE775',
        },
    ];
}